import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Pagination from "../../constant/Pagination";
import DynamicSelectInput from "../../constant/SelectInput";
import {
  getOldDepartmentList,
  createOldDepartment,
  updateOldDepartment,
  deleteOldDepartment
} from "../../../services/StaticDataListService";
import TableLoaderEffect from "../../constant/TableLoader";
import { connect } from "react-redux";

function KnowYourDepartmentPage({ userRole }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [selectedNewDept, setSelectedNewDept] = useState({})
  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const [departmentInput, setDepartmentInput] = useState({
    old_names: [""],
    new_department_id: "",
  });
  const [departmentInputError, setDepartmentInputError] = useState({
    old_names: [false],
    new_department_id: false,
  });
  const [isModalOpen, setIsModalOpen] = useState({ open: false, type: "Add" });
  const [total, setTotal] = useState(0);
  const recordsPage = 10;

  useEffect(() => {
    if (!searchQuery.length > 0) {
      setIsLoading(true)
    }
    getOldDepartmentList(currentPage, recordsPage, searchQuery)
      .then((resp) => {
        setData(resp.data.results);
        setTotal(resp.data.count);
        setIsLoading(false);
        setIsSearchLoading(false)
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message);
        } else {
          console.log(error);
        }
        setIsLoading(false);
        setIsSearchLoading(false)
      });
  }, [currentPage, searchQuery]);

  const toggleModal = (type = "Add", item = null) => {
    let open = isModalOpen.open;

    if (type === "Add") {
      open = !open;
    } else if (["Edit", "Delete"].includes(type) && item) {
      setDepartmentInput({
        id: item.id,
        old_names: item.old_names,
        new_department_id: item.new_department.department_id,
      });
      setSelectedNewDept({label:item.new_department.name, value:item.new_department.department_id})
      open = true;
    }
    if (isModalOpen.open && item === null) {
      setDepartmentInput({
        old_names: [""],
        new_department_id: "",
      });
      setDepartmentInputError({
        old_names: [false],
        new_department_id: false,
      });
      setSelectedNewDept({})
    }
    setIsModalOpen({ type, open });
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setIsSearchLoading(true)
    setCurrentPage(1)
    setSearchQuery(value);
  };


  const handleOldNamesChange = (e, index) => {
    const { value } = e.target;
    const descriptionList = [...departmentInput.old_names];
    descriptionList[index] = value;
    setDepartmentInput({ ...departmentInput, old_names: descriptionList });
    const old_names_error = departmentInputError.old_names
    old_names_error[index] = value.length === 0
    setDepartmentInputError({ ...departmentInputError, old_names: old_names_error })
  };

  const handleAddOldNames = () => {
    const old_names = [...departmentInput.old_names, ""]
    setDepartmentInput({
      ...departmentInput,
      old_names
    });
    setDepartmentInputError({ ...departmentInputError, old_names: [...departmentInputError.old_names, false] })
  };

  const handleRemoveOldNames = (indexToRemove) => {
    const old_names = departmentInput.old_names
    old_names.splice(indexToRemove, 1)
    setDepartmentInput({
      ...departmentInput,
      old_names
    });
    const old_names_error = departmentInputError.old_names
    old_names_error.splice(indexToRemove, 1)
    setDepartmentInputError({ ...departmentInputError, old_names: old_names_error })
  };

  const handlePagination = (page) => {
    const new_page = page.selected + 1;
    setCurrentPage(new_page);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    let isValid = true
    if (!departmentInput.new_department_id) {
      errors['new_department_id'] = true
      isValid = false
    } else {
      errors['new_department_id'] = false
    }
    const old_name_error = departmentInput.old_names.map(item => !item)
    if (old_name_error.some(item => item)) {
      isValid = false
    }
    errors["old_names"] = old_name_error
    setDepartmentInputError(errors);
    if (!isValid) {
      return;
    }

    if (isModalOpen.type === "Add") {
      try {
        setIsSubmitLoading(true)
        const resp = await createOldDepartment(departmentInput);
        const resp_data = resp.data.results;
        setData([resp_data, ...data]);
        setTotal(total + 1);
        toast.success(resp.data.message);
        toggleModal();
      } catch (error) {
        toast.error(error.response.data.message);
      }
      finally {
        setIsSubmitLoading(false)
      }
    } else {
      try {
        setIsSubmitLoading(true)
        const response = await updateOldDepartment(departmentInput);
        const resp_data = response.data.results;
        setData(
          data.map((item) =>
            item.id === resp_data.id ? { ...resp_data } : item
          )
        );
        toast.success(response.data.message);
        toggleModal();
      } catch (error) {
        console.log(error);
        if (error && error.response) {
          toast.error(error.response.data.message);
        }
      }
      finally {
        setIsSubmitLoading(false)
      }
    }
  };

  const handleSelectChange = (name, value, _) => {
    setDepartmentInput({ ...departmentInput, [name]: value });
  };


  const onDeleteSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitLoading(true)
      const resp = await deleteOldDepartment(departmentInput.id);
      const resp_data = resp.data.results;
      setData(data.filter(item => item.id !== resp_data));
      setTotal(total - 1);
      toast.success(resp.data.message);
      toggleModal();
    } catch (error) {
      toast.error(error.response.data.message);
    }
    finally {
      setIsSubmitLoading(false)
    }
  }

  return (
    <>
      <div className="container-fluid">
        <div className="card">
          <div className="d-flex justify-content-between text-wrap flex-column  flex-sm-row align-items-start align-items-sm-center p-3">
            <h4 className="heading fw-bold mb-3 mb-md-0">Kown Your Department</h4>
            <div className="d-flex align-items-start align-items-sm-center flex-column flex-sm-row">
              <div className="me-3 mb-md-0">
                <div className="input-group tp-input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchQuery}
                    aria-describedby="basic-search"
                    onChange={handleSearchChange}
                  />
                  <div className="input-group-text" id="basic-search">
                    {isSearchLoading && <Spinner variant="primary" size="sm" />}
                    {!isSearchLoading && searchQuery.length > 0 && (
                      <span
                        className="c-pointer"
                        onClick={() => {
                          setCurrentPage(1);
                          setSearchQuery("");
                        }}
                      >
                        <i className="fa-solid fa-xmark text-primary"></i>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {userRole !== "User" &&
                <button className="btn btn-primary mt-3 mt-md-0" onClick={() => toggleModal()}>
                  Add
                </button>
              }
            </div>
          </div>
          <div className="card-body">
            <div
              className="widget-media dz-scroll  ps--active-y"
              style={{ height: "70vh" }}
            >
              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <div
                  id="employee-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="empoloyees-tblwrapper"
                    className="table ItemsCheckboxSec dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th>New Department</th>
                        <th>Old Departments</th>
                        {userRole !== "User" &&
                          <th>Action</th>
                        }
                      </tr>
                    </thead>

                    <tbody>
                      {isLoading ? (
                        <TableLoaderEffect colLength={3} />
                      ) : data.map((item, index) => (
                        <tr key={index}>
                          <td>{item.new_department.name}</td>
                          <td>{item.old_names.map((od, index) => (
                            <span className="badge badge-lg fw-bold light border-0 badge-primary badge-sm ms-2" key={index}>{od}</span>
                          ))}</td>
                          {userRole !== "User" &&
                            <td>
                              <div className="d-flex">
                                <Button
                                  onClick={() => toggleModal("Edit", item)}
                                  variant="btn btn-primary tp-btn btn-circle"
                                >
                                  <i className="fa-regular fa-pen-to-square"></i>
                                </Button>
                                <Button variant="btn btn-danger tp-btn btn-circle ms-2" onClick={() => toggleModal("Delete", item)}>
                                  <i className="fa-regular fa-trash-can"></i>
                                </Button>
                              </div>
                            </td>
                          }

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              recordsPage={recordsPage}
              dataLength={total}
              handlePagination={handlePagination}
            />
          </div>
        </div>
      </div>
      {/* card end */}

      <Modal
        className="modal fade"
        id="exampleModal1"
        show={isModalOpen.open && isModalOpen.type === "Add"}
        onHide={() => toggleModal()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">
              Add Know Your Department
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => toggleModal()}
            ></button>
          </div>
          <div className="modal-body">
            <Form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-xl-12">
                  <label htmlFor="department_id" className="form-label">
                    New Department<span className="text-danger">*</span>
                  </label>
                  <DynamicSelectInput
                    setParentInputValue={handleSelectChange}
                    endpoint_name="search/department"
                    name={"new_department_id"}
                    is_invalid={departmentInputError.new_department_id}
                    id={"new_department_id"}
                    placeholder={"Select New Department"}
                    isRequired={true}
                  />
                  {departmentInputError.new_department_id && (
                    <div className="text-danger mb-3">Department is required.</div>
                  )}
                </div>
                <div className="col-xl-12">
                  <label className="form-label">
                    Old Department Name<span className="text-danger">*</span>
                  </label>
                  {departmentInput.old_names.map((item, index) => (
                    <div className="d-flex align-items-center justify-content-between mb-3" key={index}>
                      <div className="me-2 flex-fill">
                        <input
                          type="text"
                          id="old_name"
                          name="old_names"
                          placeholder="Enter Old Department Name"
                          value={item}
                          onChange={(e) => handleOldNamesChange(e, index)}
                          className={`form-control ${departmentInputError.old_names[index] ? "is-invalid" : ""
                            }`}
                        />
                        {departmentInputError.old_names[index] && (
                          <div className="invalid-feedback mb-2">Department ID is required</div>
                        )}
                      </div>

                      <div className="d-flex align-items-center">
                        <button
                          type="button"
                          className="btn btn-primary btn-circle me-2"
                          onClick={handleAddOldNames}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                        {departmentInput.old_names.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-circle"
                            onClick={(e) =>
                              handleRemoveOldNames(index)
                            }
                          >
                            <i className="fa-solid fa-x"></i>
                          </button>
                        )}

                      </div>

                    </div>
                  ))}
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-block btn-sm btn-primary mt-3 float-end"
                disabled={isSubmitLoading}>
                {isSubmitLoading ? (<span><Spinner size="sm" className="me-2" />Creating...</span>) : "Create"}
              </button>
            </Form>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal fade"
        id="exampleModal1"
        show={isModalOpen.open && isModalOpen.type === "Edit"}
        onHide={() => toggleModal()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">
              Edit Know Your Department
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => toggleModal()}
            ></button>
          </div>
          <div className="modal-body">
            <Form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-xl-12">
                  <label htmlFor="department_id" className="form-label">
                    New Department<span className="text-danger">*</span>
                  </label>
                  <DynamicSelectInput
                    setParentInputValue={handleSelectChange}
                    endpoint_name="search/department"
                    name={"new_department_id"}
                    defaultValue={selectedNewDept}
                    is_invalid={departmentInputError.new_department_id}
                    id={"new_department_id"}
                    placeholder={"Select New Department"}
                    isRequired={true}
                  />
                  {departmentInputError.new_department_id && (
                    <div className="text-danger mb-3">Department is required.</div>
                  )}
                </div>
                <div className="col-xl-12">
                  <label className="form-label">
                    Old Department Name<span className="text-danger">*</span>
                  </label>
                  {departmentInput.old_names.map((item, index) => (
                    <div className="d-flex align-items-center justify-content-between mb-3" key={index}>
                      <div className="me-2 flex-fill">
                        <input
                          type="text"
                          id="old_name"
                          name="old_names"
                          placeholder="Enter Old Department Name"
                          value={item}
                          onChange={(e) => handleOldNamesChange(e, index)}
                          className={`form-control ${departmentInputError.old_names[index] ? "is-invalid" : ""
                            }`}
                        />
                        {departmentInputError.old_names[index] && (
                          <div className="invalid-feedback mb-2">Department ID is required</div>
                        )}
                      </div>

                      <div className="d-flex align-items-center">
                        <button
                          type="button"
                          className="btn btn-primary btn-circle me-2"
                          onClick={handleAddOldNames}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                        {departmentInput.old_names.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-circle"
                            onClick={(e) =>
                              handleRemoveOldNames(index)
                            }
                          >
                            <i className="fa-solid fa-x"></i>
                          </button>
                        )}

                      </div>

                    </div>
                  ))}
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-block btn-sm btn-primary mt-3 float-end"
                disabled={isSubmitLoading}>
                {isSubmitLoading ? (<span><Spinner size="sm" className="me-2" />Updating...</span>) : "Update"}
              </button>
            </Form>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal modal-sm fade"
        id="exampleModal1"
        show={isModalOpen.open && isModalOpen.type === "Delete"}
        onHide={() => toggleModal()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">
              Delete Kown Your Department
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => toggleModal()}
            ></button>
          </div>
          <div className="modal-body">
            {departmentInput ?
              <Form onSubmit={onDeleteSubmit}>
                <h4>Are you sure, that you want to delete the old Department</h4>
                {departmentInput.old_names.map((od, index) => (
                            <span className="badge badge-lg fw-bold light border-0 badge-primary badge-sm ms-2" key={index}>{od}</span>
                          ))}
                
                <button
                  type="submit"
                  className="btn btn-sm w-50 btn-danger mt-4"
                  disabled={isSubmitLoading}>
                  {isSubmitLoading ? (<span><Spinner size="sm" className="me-2" />Deleting...</span>) : "Delete"}
                </button>
                
                <button
                  type="button"
                  onClick={toggleModal}
                  className="btn btn-sm btn-outline-primary mt-4 float-end"
                  disabled={isSubmitLoading}>
                  Cancel
                </button>
              </Form>
              : "Wait..."}
          </div>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
      userRole: state.auth.user?.role || "User"
  };
};

export default connect(mapStateToProps)(KnowYourDepartmentPage); 